import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { NumeroDocumentoInput } from 'sharedComponents/inputs/text'

import { KeyEventUtil } from 'utils'

const NumeroDocumentoFinFormGroup = ({ iTouched, iError, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-importe', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='DOC FIN' htmlFor='input-numeroDocumentoFin' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='numeroDocumentoFin'>
          {({ field }) => (
            <NumeroDocumentoInput
              {...field}
              id='input-numeroDocumentoFin'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroDocumentoFinFormGroup)
